import { Stage } from '../enums/app-config';

enum ImageKitStage {
  DEV = 'dev',
  TEST = 'test',
  LIVE = 'live',
}

const stageMapping = {
  [Stage.DEV]: ImageKitStage.DEV,
  [Stage.TEST]: ImageKitStage.TEST,
  [Stage.LIVE]: ImageKitStage.LIVE,
};
export function getImageKitStage() {
  return stageMapping[appConfig.stage];
}
